import { render } from "./BlogRightSidebar.vue?vue&type=template&id=1025626b&ts=true"
import script from "./BlogRightSidebar.vue?vue&type=script&lang=ts"
export * from "./BlogRightSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__